export default "__VITE_ASSET__theSH5Xx__"